import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { SPI_WIDGETS } from './spi-panel/widgets/constants';

export const SUMMARY_PANEL_TYPE = {
  SPI: 'SPI',
  NETWORK: 'NETWORK',
  FLOW: 'FLOW',
};

const DEFAULT_WIDGET_LIST = {
  EI: {
    [SUMMARY_PANEL_TYPE.SPI]: SPI_WIDGETS,
  },
  AI: {
    [SUMMARY_PANEL_TYPE.SPI]: [],
  },
  APP: {
    [SUMMARY_PANEL_TYPE.SPI]: SPI_WIDGETS,
    [SUMMARY_PANEL_TYPE.NETWORK]: [],
    [SUMMARY_PANEL_TYPE.FLOW]: [],
  },
  ODP: {
    [SUMMARY_PANEL_TYPE.SPI]: [],
  },
};

export const DEFAULT_WIDGETS: { [key: string]: any[] } = DEFAULT_WIDGET_LIST[CURRENT_PRODUCT_MODE];
